import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center md:justify-end bg-white border-b border-gray-200 flex py-4 pl-8 gap-4 flex-wrap" }
const _hoisted_2 = { class: "w-48" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "max-w-lg w-48 lg:max-w-xs" }
const _hoisted_5 = { class: "relative text-gray-600 focus-within:text-gray-600" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 pl-2 left-0 flex items-center text-sm" }, "From:", -1)
const _hoisted_7 = { class: "max-w-lg w-48 lg:max-w-xs" }
const _hoisted_8 = { class: "relative text-gray-600 focus-within:text-gray-600" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 pl-2 left-0 flex items-center text-sm" }, "To:", -1)
const _hoisted_10 = {
  key: 0,
  class: "px-8 py-6"
}
const _hoisted_11 = { class: "bg-white px-10 py-9 rounded-md shadow-md text-center" }
const _hoisted_12 = {
  key: 1,
  class: "px-8 py-6"
}
const _hoisted_13 = { class: "grid grid-cols-1 gap-6 lg:grid-cols-2" }
const _hoisted_14 = { class: "bg-white shadow sm:rounded-md overflow-x-auto" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-3 border-b border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-base font-semibold text-gray-800" }, "Deposit")
], -1)
const _hoisted_16 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Admin"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Amount (total)"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Count"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3" })
  ])
], -1)
const _hoisted_18 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "px-4 py-4 text-center text-sm text-gray-400"
}, "No data", -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "px-4 py-3 whitespace-nowrap text-sm text-gray-700" }
const _hoisted_23 = { class: "px-4 py-3 whitespace-nowrap text-sm text-gray-700 text-right" }
const _hoisted_24 = { class: "px-4 py-3 whitespace-nowrap text-sm text-gray-700 text-right" }
const _hoisted_25 = { class: "px-4 py-3 whitespace-nowrap text-sm text-right" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "bg-white shadow sm:rounded-md overflow-x-auto" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-3 border-b border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-base font-semibold text-gray-800" }, "Withdraw")
], -1)
const _hoisted_29 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Admin"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Amount (total)"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Count"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3" })
  ])
], -1)
const _hoisted_31 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "px-4 py-4 text-center text-sm text-gray-400"
}, "No data", -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "px-4 py-3 whitespace-nowrap text-sm text-gray-700" }
const _hoisted_36 = { class: "px-4 py-3 whitespace-nowrap text-sm text-gray-700 text-right" }
const _hoisted_37 = { class: "px-4 py-3 whitespace-nowrap text-sm text-gray-700 text-right" }
const _hoisted_38 = { class: "px-4 py-3 whitespace-nowrap text-sm text-right" }
const _hoisted_39 = ["onClick"]

import dayjs from 'dayjs';
import { AxiosInstance } from 'axios';
import { inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import Navbar from '@/components/tools/Navbar.vue';
import ApprovalReportDetailDialog from '@/components/dialogs/ApprovalReportDetailDialog.vue';

interface AuditRow {
  adminId: string;
  adminUsername: string;
  totalAmount: string;
  count: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentApprovalReport',
  setup(__props) {

const axios = inject('$axios') as AxiosInstance;
const store = useStore();

const rangeOptions = [
  { label: 'Today', value: 'today' },
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'Last Week', value: 'lastweek' },
  { label: 'Last Month', value: 'lastmonth' },
];

const selectedRange = ref('today');
const fromDate = ref(dayjs().format('YYYY-MM-DD'));
const toDate = ref(dayjs().format('YYYY-MM-DD'));
const isLoaded = ref(true);

const onRangeChange = () => {
  const now = dayjs();
  switch (selectedRange.value) {
    case 'today':
      fromDate.value = now.format('YYYY-MM-DD');
      toDate.value = now.format('YYYY-MM-DD');
      break;
    case 'yesterday':
      fromDate.value = now.subtract(1, 'day').format('YYYY-MM-DD');
      toDate.value = now.subtract(1, 'day').format('YYYY-MM-DD');
      break;
    case 'lastweek':
      fromDate.value = now.subtract(1, 'week').startOf('week').format('YYYY-MM-DD');
      toDate.value = now.subtract(1, 'week').endOf('week').format('YYYY-MM-DD');
      break;
    case 'lastmonth':
      fromDate.value = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
      toDate.value = now.subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
      break;
  }
};

const reportData = ref<{ deposit: AuditRow[]; withdraw: AuditRow[] }>({
  deposit: [],
  withdraw: [],
});

const detailDialog = ref<{
  show: boolean;
  adminId: string;
  adminUsername: string;
  approvedType: 'deposit' | 'withdraw';
}>({
  show: false,
  adminId: '',
  adminUsername: '',
  approvedType: 'deposit',
});

const openDetail = (row: AuditRow, type: 'deposit' | 'withdraw') => {
  detailDialog.value = {
    show: true,
    adminId: row.adminId,
    adminUsername: row.adminUsername,
    approvedType: type,
  };
};

const formatAmount = (amount: string | number): string => {
  return (Number(amount) / 100).toLocaleString('en', {
    useGrouping: true,
    minimumFractionDigits: 2,
  });
};

const fetchReport = async () => {
  isLoaded.value = false;
  try {
    const { data } = await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/transaction-admin-audit/report`,
      {
        operatorId: store.state.selectedOperator.operatorId,
        startDate: dayjs(fromDate.value).startOf('day').toISOString(),
        endDate: dayjs(toDate.value).endOf('day').toISOString(),
      },
    );
    reportData.value = data;
  } catch (e) {
    console.error(e);
  } finally {
    isLoaded.value = true;
  }
};

onMounted(() => {
  fetchReport();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, { title: "Payment Approval Report" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedRange).value = $event)),
          onChange: onRangeChange,
          class: "block w-full bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm sm:text-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(rangeOptions, (opt) => {
            return _createElementVNode("option", {
              key: opt.value,
              value: opt.value
            }, _toDisplayString(opt.label), 9, _hoisted_3)
          }), 64))
        ], 544), [
          [_vModelSelect, selectedRange.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fromDate).value = $event)),
            type: "date",
            class: "block w-full bg-white py-2 pl-16 pr-3 border border-gray-300 rounded-md sm:text-sm"
          }, null, 512), [
            [_vModelText, fromDate.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((toDate).value = $event)),
            type: "date",
            class: "block w-full bg-white py-2 pl-10 pr-3 border border-gray-300 rounded-md sm:text-sm"
          }, null, 512), [
            [_vModelText, toDate.value]
          ])
        ])
      ]),
      _createElementVNode("div", { class: "flex-shrink-0 flex md:ml-4 pr-8" }, [
        _createElementVNode("button", {
          type: "button",
          onClick: fetchReport,
          class: "inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        }, " Search ")
      ])
    ]),
    (!isLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_font_awesome_icon, {
              class: "text-gray-500",
              icon: ['fas', 'circle-notch'],
              spin: ""
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (isLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("table", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("tbody", _hoisted_18, [
                  (reportData.value.deposit.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_19, _hoisted_21))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportData.value.deposit, (row) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: row.adminId,
                      class: "hover:bg-gray-50"
                    }, [
                      _createElementVNode("td", _hoisted_22, _toDisplayString(row.adminUsername), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(formatAmount(row.totalAmount)), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(Number(row.count).toLocaleString('en')), 1),
                      _createElementVNode("td", _hoisted_25, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: ($event: any) => (openDetail(row, 'deposit')),
                          class: "inline-flex items-center px-3 py-1 border border-transparent rounded-md text-xs font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        }, " View List ", 8, _hoisted_26)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("table", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("tbody", _hoisted_31, [
                  (reportData.value.withdraw.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_32, _hoisted_34))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportData.value.withdraw, (row) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: row.adminId,
                      class: "hover:bg-gray-50"
                    }, [
                      _createElementVNode("td", _hoisted_35, _toDisplayString(row.adminUsername), 1),
                      _createElementVNode("td", _hoisted_36, _toDisplayString(formatAmount(row.totalAmount)), 1),
                      _createElementVNode("td", _hoisted_37, _toDisplayString(Number(row.count).toLocaleString('en')), 1),
                      _createElementVNode("td", _hoisted_38, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: ($event: any) => (openDetail(row, 'withdraw')),
                          class: "inline-flex items-center px-3 py-1 border border-transparent rounded-md text-xs font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        }, " View List ", 8, _hoisted_39)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(ApprovalReportDetailDialog, {
      show: detailDialog.value.show,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((detailDialog.value.show) = $event)),
      adminId: detailDialog.value.adminId,
      adminUsername: detailDialog.value.adminUsername,
      approvedType: detailDialog.value.approvedType,
      startDate: fromDate.value,
      endDate: toDate.value
    }, null, 8, ["show", "adminId", "adminUsername", "approvedType", "startDate", "endDate"])
  ], 64))
}
}

})